import React from 'react';
import { Container, Row, Col,Card, CardText, CardBody,
    CardTitle, Button } from 'reactstrap';
import './News.css';
import Axios from 'axios';
import Config from '../../Core/Config.js';
import {framework,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class NewsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      news: [
        { companyName: 'شرکت سامان نگار ایرانیان', addressCo: 'تهران', faxCo: '84325', telCo: '84325', locationCo: '627.2238657537844 M' },
        { companyName: 'سید عبدالکریم طیبی', addressCo: 'شیراز- بلوار زرهی - ابتدای بلوار بعثت', faxCo: '07136489146', telCo: '07136489146', locationCo: '627.2238657537844 M' },
        { companyName: 'محبوبه کریمی', addressCo: 'تهران - میدان ولیعصر - ساختمان تجارت ایرانیان - طبقه 9 - واحد 18', faxCo: '88899378', telCo: '88896617', locationCo: '627.2238657537844 M' },
        { companyName: 'سید عبدالکریم طیبی', addressCo: 'شیراز- بلوار زرهی - ابتدای بلوار بعثت', faxCo: '07136489146', telCo: '07136489146', locationCo: '627.2238657537844 M' },
        { companyName: 'شرکت سامان نگار ایرانیان', addressCo: 'تهران', faxCo: '84325', telCo: '84325', locationCo: '627.2238657537844 M' },
        { companyName: 'سید عبدالکریم طیبی', addressCo: 'شیراز- بلوار زرهی - ابتدای بلوار بعثت', faxCo: '07136489146', telCo: '07136489146', locationCo: '627.2238657537844 M' },
      ],
    };
    this.state.news=[];
    Axios.get(Config.domain_pic+"/GetNews?"+
            "UserId="+0+"&LanguageBaseId="+11+"&Title=&NewsTypeBaseId="+165+"&IsSpecial=&OrderBy=createddate&FromRecord="+0+"&PageSize="+50+"&Direction=Desc&OnlyLikedString="
        )
        .then((result) => {
            // console.log("result.news: ", JSON.stringify(result.data));
            this.setState({ news: result.data, isLoading: false });
  }
        )
  }
  render() {
    const { news } = this.state;
    return (

      <div>
          <br/>
           <Container>
           { !this.state.isLoading ? (
        <Row className="listNews">
          {news.map((newsItem) => (
            
              <Col sm="12" md="4">
                <Card>
                  <div className="img_holder-card">
                    <img  src={'http://mobapp.novininsurance.com/UploadImages/News/'+newsItem.FileName1+'.jpg'} alt={newsItem.Title} />
                  </div>
        
        <CardBody>
          <CardTitle>{newsItem.Title}</CardTitle>
          <CardText >{newsItem.Context}</CardText>
          <Button onClick={()=>PageManager.changePage(Config.p_singlenews, [newsItem.NewsId])}>بیشتر...</Button>
        </CardBody>
      </Card>
      </Col>
     
          ))}
          
 </Row>
          ): (<ui.Preloader />)}</Container>
        <br/>
      </div>
    );
  }
}
export default NewsList;


// WEBPACK FOOTER //
// ./src/components/News/NewsList.js